module.exports = new __parcel__URL__("beetlejuice-geena-davis.648847bc.gif").toString();